// Licensing and credit fields for every ImageObject in JSON-LD.
// Group A: photos taken by the owner (credited to 1 Wood Floors). Everything else is Group B.
export const IMAGE_ORGANIZATION = { "@type": "Organization", name: "1 Wood Floors", url: "https://1woodfloors.com/" };
export const PHOTOGRAPHER = { "@type": "Organization", name: "Jaime Ann Photography" };

export const OWNER_PHOTO_PAGES = [
  "/projects/ann-arbor-tech",
  "/projects/ann-arbor-subfloor",
  "/projects/livonia-subfloor",
  "/projects/northville-subfloor",
  "/subfloor-leveling",
];

// Base file names (no hash, no extension) of owner photos, matched wherever they are reused.
export const OWNER_PHOTO_BASENAMES = new Set([
  "1-wood-floors-logo",
  "self-leveling-underlayment-deep-pour-ann-arbor-mi",
  "schonox-collomix-subfloor-leveling-1-wood-floors",
  "hepa-vacuum-dust-control-mixing-station-1-wood-floors",
  "commercial-oak-staircase-pallmann-magic-oil-ann-arbor-mi",
  "ann-arbor-tech-floor-detail",
  "ann-arbor-tech-staircase",
  "ann-arbor-tech-open-floor",
  "ann-arbor-tech-lobby",
  "ann-arbor-tech-staircase-levels",
  "ann-arbor-tech-staircase-aerial",
  "ann-arbor-tech-staircase-hero",
  "plywood-subfloor-evaluation-northville-mi",
  "bare-plywood-subfloor-evaluation-1-wood-floors-northville-mi",
  "specialized-blue-subfloor-primer-1-wood-floors",
  "needle-rolling-self-leveling-underlayment-1-wood-floors-northville",
  "self-leveling-underlayment-pour-concrete-livonia-mi",
  "subfloor-bonding-primer-over-mastic-livonia-mi",
  "custom-8-inch-hickory-hardwood-michigan-plank-fireside",
  "floor-joist-repair-structural-dip-correction",
  "subfloor-hard-shim-plywood-low-spot-correction",
  "deep-self-leveling-underlayment-pour-ann-arbor-mi",
  "subfloor-hero",
  "northville-walnut-slu-pour",
  "northville-walnut-slu-craftsman",
  "commercial-ann-arbor",
  "spirit-level-concrete-subfloor-leveling-prep",
]);

export function imageBaseName(url) {
  if (typeof url !== "string") return "";
  const file = url.split("?")[0].split("/").pop() || "";
  const noExt = file.replace(/\.(webp|jpe?g|png|avif|gif)$/i, "");
  return noExt.replace(/-[A-Za-z0-9_-]{8}$/, "");
}

function normalizePath(path) {
  if (typeof path !== "string") return "";
  const p = path.replace(/^https?:\/\/[^/]+/, "").split(/[?#]/)[0].replace(/\/+$/, "");
  return p || "/";
}

// Photos by Jaime Ann Photography keep the photographer credit even on owner photo pages.
export const PHOTOGRAPHER_PHOTO_BASENAMES = new Set([
  "michigan-plank-hickory-fireside-dining-table-livonia-mi",
  "michigan-plank-hickory-fireside-living-room-sofa-livonia-mi",
  "michigan-plank-hickory-fireside-dining-hutch-livonia-mi",
  "michigan-plank-hickory-fireside-long-boards-sideboard-livonia-mi",
  "michigan-plank-hickory-fireside-grain-closeup-livonia-mi",
]);

function isOwnerPhoto(image, pagePath) {
  if ([image.contentUrl, image.url].some(u => PHOTOGRAPHER_PHOTO_BASENAMES.has(imageBaseName(u)))) return false;
  if (OWNER_PHOTO_PAGES.includes(normalizePath(pagePath))) return true;
  const idPage = typeof image["@id"] === "string" ? normalizePath(image["@id"]) : "";
  if (OWNER_PHOTO_PAGES.includes(idPage)) return true;
  return [image.contentUrl, image.url].some(u => OWNER_PHOTO_BASENAMES.has(imageBaseName(u)));
}

function isImageObject(value) {
  const types = Array.isArray(value["@type"]) ? value["@type"] : [value["@type"]];
  return types.includes("ImageObject");
}

// Recursively adds licensing and credit fields to every ImageObject; all other fields are preserved.
export function withImageLicensing(value, pagePath) {
  if (Array.isArray(value)) return value.map(v => withImageLicensing(v, pagePath));
  if (!value || typeof value !== "object") return value;
  const result = Object.fromEntries(Object.entries(value).map(([k, v]) => [k, withImageLicensing(v, pagePath)]));
  if (!isImageObject(value)) return result;
  const owner = isOwnerPhoto(value, pagePath);
  result.copyrightHolder = { ...IMAGE_ORGANIZATION };
  result.copyrightNotice = "© 1 Wood Floors";
  result.license = "https://1woodfloors.com/contact";
  result.acquireLicensePage = "https://1woodfloors.com/contact";
  result.creator = owner ? { ...IMAGE_ORGANIZATION } : { ...PHOTOGRAPHER };
  result.creditText = owner ? "1 Wood Floors" : "Jaime Ann Photography for 1 Wood Floors";
  return result;
}
